/**
 * ajax 模块，可以将 axios 替换成 $.ajax 等
 */
import axios from 'axios'
// import Cookies from 'js-cookie'
import { catchError, catchResponse } from '@/assets/js/util.js'

const Axios = axios.create({
  timeout: 60000
})

// 暂时不启用过滤
// 添加请求拦截器
Axios.defaults.headers['Cache-Control'] = 'no-cache'
Axios.defaults.headers['Pragma'] = 'no-cache'
Axios.defaults.headers['Authorization'] = 'Basic d3BmbHk6ZjY2NjY2Ng=='

Axios.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 返回状态判断(添加响应拦截器)
Axios.interceptors.response.use(
  response => {
    return catchResponse(response.data)
  },
  function (error) {
    return catchError(error)
  }
)

export default Axios



// WEBPACK FOOTER //
// ./src/assets/js/AxiosPlugin.js